import React from "react";
import classnames from "classnames";
import LoadingIcon from './LoadingIcon';

const componentClass = 'loadingOverlay';

const LoadingOverlay = ({ className, isOpaque, message }) => {
  const classes = classnames(componentClass, className, {
    [`${componentClass}--isOpaque`]: isOpaque
  });

  return <div className={classes}>
    <LoadingIcon />
    { message && <p>{ message }</p> }
  </div>;
}
export default LoadingOverlay;
